import { useMode } from "../mode/ModeContext";

/** A persistent amber bar shown whenever the sandbox (test mode) is active, so users always know
 *  nothing they see or do is real — it never affects live data or other users. */
export function TestModeBanner() {
  const { isTest, switchMode } = useMode();
  if (!isTest) return null;
  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-[#c9a227] px-4 py-1.5 text-center text-[12px] font-bold text-black"
    >
      <span>🧪 TEST MODE — sandbox data. Nothing here is real; it won't affect live data or other users.</span>
      <button
        type="button"
        onClick={() => void switchMode("live")}
        className="rounded bg-black/15 px-2 py-0.5 text-[11px] uppercase tracking-wide hover:bg-black/25"
      >
        Exit test mode
      </button>
    </div>
  );
}
